
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[profileId]",
      function () {
        return require("private-next-pages/[profileId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[profileId]"])
      });
    }
  